/** ***********************************************************************
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ************************************************************************* */

import React, { Component } from 'react';
import { observer } from 'mobx-react';
import OverviewKeyFeatures from './overviewKeyFeatures';
import Tutorials from './tutorials';
import BehanceGallery from './behanceGallery';
import './leftPanel.scss';

class PDPLeftPanel extends Component {
    render() {
        const {
            layouts,
            PDPDataObject,
            appConfig,
            appsPanelSkeleton,
        } = this.props;

        // (TODO)ShowExpandFeaures needs to be handled

        return (
            <div className="pdp-body-left-panel">
                <OverviewKeyFeatures
                    PDPDataObject={PDPDataObject}
                    appConfig={appConfig}
                    appsPanelSkeleton={appsPanelSkeleton}
                    layouts={layouts} />
                <Tutorials PDPDataObject={PDPDataObject} />
                <BehanceGallery PDPDataObject={PDPDataObject} />
            </div>
        );
    }
}

export default observer(PDPLeftPanel);
